<script setup>
import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";
import {ref, computed, watch} from "vue";
import EditableBtn from "./portal-editable-fields/EditableBtn.vue";
import EditableTextField from "./portal-editable-fields/EditableTextField.vue";
import ValidationErrors from "../common/ValidationErrors.vue";

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const emit = defineEmits(['modal-off']);

    const addUrl = route('partners_int.custom_links.add');

    const props = defineProps({
        programLinks: {
            type: Array,
            default: () => []
        }
    })

   const key = ref('')
   const error = ref(null)
   const loading = ref(false)
   const create_allowed = ref(false)
   const program_link_index = ref(0)
   const program_link = ref(props.programLinks[0])
   const createRefLinkModal = ref(null)


    const addCustomLink = () => {

        if (loading.value || !create_allowed.value) {
            return;
        }

        error.value = null;
        loading.value = true;

        axios
            .post(addUrl, {key: key.value, domain_id: program_link.value.id, is_additional: program_link.value.is_additional})
            .then(response => {
                if (+response.data.status === 1) {
                    if(createRefLinkModal.value) {
                        createRefLinkModal.value.showModal = false;
                    }
                    portalContentAndDesignStore.resourcesPageSettings.custom_links.push(
                        response.data.data
                    );
                    emit('modal-off', 'partner_add_custom_link');
                } else {
                    error.value = response.data?.error || response.data?.errors || 'Failed to update custom link';
                }
            })
            .catch(resError => {
                if (resError.response && resError.response.status === 422) {
                    error.value = resError.response?.data?.errors || 'Something went wrong';
                } else {
                    console.log('Creating link error:', error.response);
                    error.value = resError.response?.data?.error || 'An error occurred. See console for details.';
                }
            }).finally(() => loading.value = false);
    }

    watch(() => key.value, (newValue) => {
        create_allowed.value = newValue.trim().replaceAll(' ', '').length > 4;
    });

    const programLinkChange = (event) => {
            program_link.value = props.programLinks[event.target.value];
    }

    const ref_link = computed(() => {
        return program_link.value.url + key.value;
    });

</script>
<template>
    <modal
       v-if="programLinks.length > 0"
       :title="portalContentAndDesignStore.translationSettings.portal_translation_features_referral_url"
       :cancel_btn_title="portalContentAndDesignStore.translationSettings.portal_translation_general_cancel"
       size="small"
       name="partner_add_custom_link"
       ref="createRefLinkModal"
    >
        <template #toggle>
            <editable-btn type="light"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_features_create_new_ref_url"
            />
        </template>
        <template #body>
            <div class="space-y-4">
                <validation-errors :errors="error" />
                <div>
                    <select id="program_custom_link" name="program_custom_link" v-model="program_link_index"
                            @change="programLinkChange"
                            class="block w-full rounded border-gray-300 sm:text-sm focus:ring-0 focus:border-gray-400">
                        <option v-for="(link, index) in programLinks" v-bind:value="index">
                            {{ link.domain }}
                        </option>
                    </select>
                </div>
                <editable-text-field
                    text-type="label"
                    for-attribute="identification"
                    :v-model="portalContentAndDesignStore.translationSettings.portal_translation_features_idetification_code"
                    :class="portalContentAndDesignStore.getTextColorClass"
                />
                <input type="text"
                    v-model="key"
                    id="identification"
                    name="identification"
                    :class="portalContentAndDesignStore.getInputStyle"
                    v-on:keyup.enter="addCustomLink"
                >
                <div
                    class="py-3 px-4 text-sm bg-gray-100 text-gray-900 text-opacity-60 rounded flex items-center space-x-1.5">
                    <icon name="link"></icon>
                    <span>{{ ref_link }}</span>
                </div>
            </div>
        </template>
        <template #footer>
            <editable-btn v-on:click="addCustomLink"
                          :loading="loading"
                          :disabled="!create_allowed"
                          v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_create"
            />
        </template>
    </modal>
</template>

